import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TLM_MASTER } from "../apiRoutes";

interface TlmMasterResponse {
  data: any;
}

const fetchTlmMasterDetail = async (id: string) => {
  const response = await axiosAuth.get<TlmMasterResponse>(
    `${TLM_MASTER}${id}`
  );
  return response.data;
};

const useGetTlmMasterDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["tlmMasterDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["tlmMasterDetail", string | undefined]>({
    queryKey: ["tlmMasterDetail", id],
    queryFn: () => fetchTlmMasterDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetTlmMasterDetailQuery;


